module.exports = __webpack_public_path__ + "img/gongsigonggao.4e6e4c55.png";